import Dialog from "@mui/material/Dialog";
import useStyles from "./styles";
import { CustomTypography } from "../CustomTypography/CustomTypography";
import { colors } from "../../styles/colors";
import { CustomIconButton } from "../CustomIconButton/CustomIconButton";
import { CustomButton } from "../CustomButton/CustomButton";
import { useTranslation } from "react-i18next";

type Props = {
  width?: string | number;
  children: React.ReactNode;
  title: string;
  open: boolean;
  onClose?: () => void;
  onCancel?: () => void;
  onSave?: () => void;
  isConfirmation?: boolean;
  textConfirmation?: string;
  labelConfirmation?: string;
  disabledSaveButton?: boolean | undefined;
  loadingSave?: boolean;
  onConfirm?: () => void;
};

export const CustomModal: React.FC<Props> = ({
  width,
  children,
  title,
  open,
  isConfirmation,
  textConfirmation,
  labelConfirmation,
  disabledSaveButton,
  loadingSave,
  onConfirm,
  onClose,
  onCancel,
  onSave,
}) => {
  const classes = useStyles({ width });
  const { t } = useTranslation();

  return (
    <Dialog open={open} className={classes.containerDialog}>
      <div className={classes.titleContainer}>
        <CustomTypography
          text={
            isConfirmation ? t("common.confirmation", "Confirmation") : title
          }
          variant={"h5"}
          color={isConfirmation ? colors.secondary : colors.primary}
          isUppercase
        />
        <CustomIconButton
          color={colors.BLACK}
          backgroundColor={colors.elevatedSurface}
          widthIcon={"25px"}
          heightIcon={"25px"}
          iconName="close"
          onClick={onClose}
        />
      </div>
      {children}
      <div className={classes.buttonContainer}>
        <CustomButton
          label={t("common.cancel", "Cancel")}
          variant={"default"}
          textVariant={"link"}
          fontWeight={"bold"}
          width={"fit-content"}
          padding={"3px 16px"}
          onClick={onCancel}
        />
        {isConfirmation && textConfirmation ? (
          <CustomButton
            label={textConfirmation}
            variant={"secondary"}
            textVariant={"link"}
            fontWeight={"bold"}
            width={"fit-content"}
            padding={"3px 16px"}
            onClick={onConfirm}
          />
        ) : (
          <CustomButton
            label={
              labelConfirmation ? labelConfirmation : t("common.saveButton", "Save")
            }
            loading={loadingSave}
            disabled={disabledSaveButton}
            variant={disabledSaveButton ? "disabled" : "primary"}
            textVariant={"link"}
            fontWeight={"bold"}
            width={"fit-content"}
            padding={"3px 16px"}
            onClick={onSave}
          />
        )}
      </div>
    </Dialog>
  );
};
